<template>
  <div class="news__news-boxes">
    <NewsBox
      v-for="news in newsList"
      :key="news.id"
      :news-id="news.id"
      :news-title="news.title"
      :started-at="news.startedAt"
    />
  </div>
</template>
<script>
import NewsBox from './NewsBox.vue'
export default {
  components: { NewsBox },
  props: {
    newsList: {
      type: Array,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.news {
  &__news-boxes {
    max-width: $max-contents-width;
    margin: auto;
    padding: 0 16px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
